import { createModel } from 'ibiza'
import { validate } from 'email-validator'
import Fetch from 'lib/fetch'

const useModel = createModel('node-list', (props) => ({
  adding: false,
  saving: false,
  permittedUsers: [],

  // node permission params
  environment: null,
  updatedToken: null,
  tenant: null,
  node: null,
  baseline: true,
  operational_state: true,

  addingUser: false,
  draftUser: {},
  get draftUserOK() {
    return validate(this.draftUser?.email)
  },
  savingUser: false,

  get hasChanges() {
    return (
      this.permittedUsers.length > 0 &&
      this.node &&
      this.environment &&
      this.tenant
    )
  },

  cancel() {
    this.permittedUsers = []

    this.adding = false
  },

  get permissionsPayload() {
    let payload = []
    this.permittedUsers.forEach((userId) => {
      payload.push({
        permitted_user_id: userId,
        tenant_id: this.tenant.id,
        tenant_name: this.tenant.label,
        environment: this.environment.label,
        node_name: this.node.label,
        node_id: this.node.id,
        baseline: this.baseline,
        operational_state: this.operational_state,
      })
    })
    return payload
  },

  get permissionsUrl() {
    return `/environments/${this.environment?.id}/tenants/${this.tenant?.id}/nodes/${this.node.id}/permissions`
  },

  reset() {
    this.tenant = null
    this.environment = null
    this.node = null
    this.permittedUsers = []
    this.baseline = true
    this.operational_state = true
    this.adding = false
  },

  ...props,
}))

export default useModel
